module.exports = __webpack_public_path__ + "img/Weapon_36.ba9f21e6.png";